<template>
  <b-form-group
    label="Katalog Durumu"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Katalog Durumu"
      rules="required"
    >
      <v-select
        v-model="dataItem.status"
        :options="statuses"
        label="title"
        :reduce="status => status.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'Status',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
      statuses: [
        {
          id: '0',
          title: 'Katalog Açık',
        },
        {
          id: '1',
          title: 'Katalog Kapalı',
        },
      ],
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['catalogStatuses/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
